export default {
  getFacilidades: state => state.facilidades,
}
